module.exports = "pegasus_template/assets/background-patterns/default-automotive-theme.jpg";